export default "__VITE_ASSET__DwKNsWi7__"